module.exports = __webpack_public_path__ + "img/dw2.7f33e982.jpg";